import { buttonClasses } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

export const MuiButton: Components<Theme>["MuiButton"] = {
  styleOverrides: {
    loadingIndicator: {
      lineHeight: 0,
    },
    root: () => {
      return {
        borderColor: "currentColor",

        [`&.${buttonClasses.colorSuccess}:not(.${buttonClasses.disabled}):not(.${buttonClasses.contained})`]:
          {
            color: `light-dark(var(--mui-palette-success-main), var(--mui-palette-success-light))`,
          },

        [`&.${buttonClasses.colorError}:not(.${buttonClasses.disabled}):not(.${buttonClasses.contained})`]:
          {
            color: `light-dark(var(--mui-palette-error-main), var(--mui-palette-error-light))`,
          },

        [`&.${buttonClasses.contained}.${buttonClasses.colorError}:not(.${buttonClasses.disabled})`]:
          {
            "--variant-containedColor": "var(--mui-palette-common-white)",
          },
      };
    },
  },
};
